import MathText from '../MathText';
import {
  getQuestionText,
  getQuestionImageUrl,
  getQuestionOptions,
  getCorrectOptionIds,
  getCorrectAnswerText,
  getQuestionExplanation,
  getQuestionTags
} from '../../utils/question';

// The single canonical question view: stem, options with the correct one(s)
// highlighted, explanation, tags and id. Used everywhere a question is shown.
export default function QuestionDetail({ question }) {
  const imageUrl = getQuestionImageUrl(question);
  const options = getQuestionOptions(question);
  const correctIds = getCorrectOptionIds(question, options);
  const fallbackAnswer = correctIds.size ? '' : getCorrectAnswerText(question, options);
  const explanation = getQuestionExplanation(question);
  const tags = getQuestionTags(question);

  return (
    <div className="question-detail">
      <p className="question-stem">
        <MathText text={getQuestionText(question)} />
      </p>
      {imageUrl && (
        <div className="question-image-wrap">
          <img src={imageUrl} alt="Question diagram" className="question-image" loading="lazy" />
        </div>
      )}
      {options.length > 0 && (
        <div className="question-options">
          {options.map((option, index) => {
            const correct = correctIds.has(option.id);
            return (
              <div key={`${option.id}-${index}`} className={`question-option ${correct ? 'correct' : ''}`}>
                <span className="question-option-marker">{correct ? '✓' : String.fromCharCode(65 + index)}</span>
                <div className="question-option-content">
                  {option.label && <span><MathText text={option.label} /></span>}
                  {option.imageUrl && (
                    <img src={option.imageUrl} alt={`Option ${String.fromCharCode(65 + index)} diagram`} className="option-image" loading="lazy" />
                  )}
                </div>
                {correct && <span className="question-option-badge">Correct</span>}
              </div>
            );
          })}
        </div>
      )}
      {fallbackAnswer && (
        <div className="question-detail-section">
          <h4>Correct answer</h4>
          <p><MathText text={fallbackAnswer} /></p>
        </div>
      )}
      <div className="question-detail-section">
        <h4>Explanation</h4>
        <p>{explanation ? <MathText text={explanation} /> : 'No explanation provided.'}</p>
      </div>
      {(tags.length > 0 || question?.id) && (
        <div className="question-detail-meta">
          {tags.length > 0 && (
            <span className="question-tags">
              {tags.map((tag) => <span key={tag} className="question-tag">{tag}</span>)}
            </span>
          )}
          {question?.id && <small className="muted">ID: {question.id}</small>}
        </div>
      )}
    </div>
  );
}
